import React ,{ useCallback ,useContext, useEffect, useState } from 'react'
import { t } from "i18next";
import { Checkbox, DefaultButton, PrimaryButton, TextField, ChoiceGroup, Dropdown } from "@fluentui/react";
import { studylistDateSearchFilter, viewerForNonXRAYOptions, studylistOrderByOptions } from '../../User/helpers/CheckboxOptions';
import {
  saveUserPreference,
  userPreference
} from "../../../service/UserService";
import loaderContext from '../../../context/loader/LoaderContext';
import toastContext from '../../../context/toast/ToastContext';
import { ACTIONS, AuthRoutes, TOAST_TYPE, USERTYPES, NO_OF_IMAGES_STATUS } from '../../../constants/Constants';
import userContext from '../../../context/users/UserContext';
import { useNavigate } from 'react-router-dom';
import themeContext from "../../../context/theme/ThemeContext";
import { getTimeZones } from "@vvo/tzdb";
import Select from "react-select";
import { getEnv } from '../../../helpers/EnvHelper';

const detectedTimeZone =
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

  const systemOption = {
  value: "__SYSTEM__",   // special marker
  label: `System Default (${detectedTimeZone})`
};

  const TZ_ALIAS_MAP = {
  "Asia/Calcutta": "Asia/Kolkata",
  "Asia/Saigon": "Asia/Ho_Chi_Minh",
  "US/Eastern": "America/New_York",
  "US/Central": "America/Chicago",
  "US/Mountain": "America/Denver",
  "US/Pacific": "America/Los_Angeles",
  "US/Arizona": "America/Phoenix",
  "US/Alaska": "America/Anchorage",
  "US/Hawaii": "Pacific/Honolulu",
  "GMT": "Etc/GMT",
  "UTC": "Etc/UTC",
  "Etc/UCT": "Etc/UTC",
  "Etc/Universal": "Etc/UTC",
  "Etc/Zulu": "Etc/UTC",
  "W-SU": "Europe/Moscow",
  "Eire": "Europe/Dublin",
  "Hongkong": "Asia/Hong_Kong",
  "ROC": "Asia/Taipei",
  "Egypt": "Africa/Cairo",
  "Turkey": "Europe/Istanbul"
};

const normalizeTZ = (tz) => {
  if (!tz) return getEnv("REACT_APP_BACKEND_TIMEZONE") || "UTC";
  return TZ_ALIAS_MAP[tz] || tz;
};


const timeZoneOptions = [
  ...getTimeZones().map(tz => {
    const offset = tz.rawOffsetInMinutes / 60;

    return {
      value: tz.name,
      label: `${tz.name} (UTC${offset >= 0 ? "+" : ""}${offset})`
    };
  })
];



const choiceGroupStyles = {
  label: {
    display: "inline",
  },
  flexContainer: {
    columnGap: "1em",
    flexDirection: "row",
    flexWrap: "wrap",
  },
};

const PreferenceSettings = (props) => {
  const { theme, themeName ,getThemeColor} = useContext(themeContext);
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const {isActiveData, setIsActiveData} = useContext(userContext);
  const navigate = useNavigate();

  const [preferenceData, setPreferenceData] = useState({});
  const [activeDataValue, setActiveDataValue] = useState(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : preferenceData?.user?.activeData != null ? preferenceData?.user?.activeData : true);
  const [userTimeZone, setUserTimeZone] = useState(getEnv("REACT_APP_BACKEND_TIMEZONE"));

  const [advViewerUser, setAdvanceViewerUser] = useState(false);
  const [weasisViewerUser, setWeasisViewerUser] = useState(false);
  const [infinitViewerUser, setInfinitViewerUser] = useState(false);
  const [prefetchCount, setPrefetchCount] = useState(preferenceData.prefetchCount);
  const [cINEFramesPerSecond, setCINEFramesPerSecond] = useState(preferenceData.cineFramesPerSecond || 7);
  const [errorMessage, setErrorMessage] = useState("");
  const [cineErrorMessage, setCineErrorMessage] = useState("");

  const [prefetchEntireStudy, setPrefetchEntireStudy] = useState(preferenceData.prefetchCount == -1 ? true : false);
  const [twoMonitorEnabled, setTwoMonitorEnabled] = useState(preferenceData?.twoMonitorEnabled || false);
  const [studylistOrderBy, setStudylistOrderBy] = useState(preferenceData?.studylistOrderBy != null ? Number(preferenceData.studylistOrderBy) : 1);
  const [noOfImagesFilter, setNoOfImagesFilter] = useState(preferenceData?.noOfImagesFilter != null ? preferenceData.noOfImagesFilter : null);
  const [pdfPreviewPreference, setPdfPreviewPreference] = useState(preferenceData?.pdfPreviewPreference || 0);

  const getUserPreference = async () => {
          try{setLoaderRunning(true);
          ref.current.continuousStart();
          const response = await userPreference();
          if (response.status === 200 && response.data.result === "SUCCESS") {
            setLoaderRunning(false);
            ref.current.complete();
            console.log(response);
           setPreferenceData({
            ...response.data.data.userPreference,
            studylistSearchDateFilter: response.data.data.userPreference?.studylistSearchDateFilter,
            twoMonitorEnabled: response.data.data.userPreference?.twoMonitorEnabled || false,
            autoSaveReport: response.data.data.userPreference?.autoSaveReport ?? false,
            });

            console.log("preference data :", preferenceData);
            setAdvanceViewerUser(response.data.data.advViewerUser);
            setWeasisViewerUser(response.data.data.weasisViewerUser);
            setInfinitViewerUser(response.data.data.infinitViewerUser);
            const backendTZ = normalizeTZ(response.data.data.userPreference?.userTimeZone);

            setUserTimeZone(backendTZ ? backendTZ : "__SYSTEM__");

            // setUserTimeZone(response.data.data.userPreference?.userTimeZone);
          }else{
            setLoaderRunning(false);
            ref.current.complete();
          }
        }catch(e){
            setLoaderRunning(false);
            ref.current.complete();
          }

  };

  useEffect(() => {
    getUserPreference();
    console.log("detectedTimeZone:", detectedTimeZone);
  }, []);

  const handleTwoMonitorChange = (event, checked) => {
    setTwoMonitorEnabled(checked);
  };

  useEffect(() => {
    setTwoMonitorEnabled(preferenceData?.twoMonitorEnabled || false);
    if (preferenceData.prefetchCount !== undefined) {
      setPrefetchCount(preferenceData.prefetchCount);
      setPrefetchEntireStudy(preferenceData.prefetchCount === -1);
    }
    if (preferenceData.cineFramesPerSecond) {
      setCINEFramesPerSecond(preferenceData.cineFramesPerSecond);
    }
    setStudylistOrderBy(preferenceData?.studylistOrderBy != null ? Number(preferenceData.studylistOrderBy) : 1);
    setNoOfImagesFilter(preferenceData?.noOfImagesFilter != null ? preferenceData.noOfImagesFilter : null);
    setPdfPreviewPreference(preferenceData?.pdfPreviewPreference != null ? Number(preferenceData.pdfPreviewPreference) : 0);
  }, [preferenceData]);

  const onToggleChange = (event, checked) => {
    setActiveDataValue(checked);
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setPrefetchCount(value);
    
    if (value === '' || (!isNaN(value) && parseInt(value, 10) > 0 && parseInt(value, 10) < 10000)) {
      setErrorMessage(''); 
    } else {
      setErrorMessage(t("Input must be between 1 to 10,000."));
    }
  };

  const handleCineFramesPerSecondChange = (e) => {
    const value = e.target.value;
    setCINEFramesPerSecond(value);
    
    if (value === '' || (!isNaN(value) && parseInt(value, 10) > 0 && parseInt(value, 10) <= 50)) {
      setCineErrorMessage(''); 
    } else {
      setCineErrorMessage(t("Input must be between 1 to 50."));
    }
  };



  const handleSubmitClick = async()=>{
    if((props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST) && !prefetchEntireStudy){
      if (prefetchCount == undefined || prefetchCount == '') {
        setErrorMessage(t("Autoload Count cannot be blank."));
        return;
      }else if (!prefetchEntireStudy && (parseInt(prefetchCount, 10) <= 0 || parseInt(prefetchCount, 10) > 10000)) {
        setErrorMessage(t("Input must be between 1 to 10,000."));
        return;
      }
    }

    if(props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST){
      if (cINEFramesPerSecond == undefined || cINEFramesPerSecond == '') {
        setCineErrorMessage(t("CINE Frames Per Second cannot be blank."));
        return;
      }else if (parseInt(cINEFramesPerSecond, 10) <= 0 || parseInt(cINEFramesPerSecond, 10) > 50) {
        setCineErrorMessage(t("Input must be between 1 to 50."));
        return;
      }
    }

    setLoaderRunning(true);
    ref.current.continuousStart()
  
    const tzToSave = userTimeZone === "__SYSTEM__" ? null : userTimeZone;
    const response = await saveUserPreference(
      preferenceData.outline,
      preferenceData.heatMap,
      preferenceData.nonXrayAdvanceViewer,
      preferenceData.newBasicViewer,
      preferenceData.studylistSearchDateFilter,
      activeDataValue,
      prefetchEntireStudy ? -1 : prefetchCount,
      cINEFramesPerSecond,
      twoMonitorEnabled,
      studylistOrderBy,
      noOfImagesFilter,
      tzToSave,
      pdfPreviewPreference,
      !!preferenceData.autoSaveReport,
      !!preferenceData.autoOpenNoAbnormality,
      !!preferenceData.autoOpenFoOnly,
      !!preferenceData.autoOpenAbnormality,
      !!preferenceData.autoOpenNoAiDetection,
      !!preferenceData.autoPopulateManualPathology
    );
    if (response.status === 200 && response.data.result === "SUCCESS") {
      setIsActiveData(getEnv("REACT_APP_PARTITION_MODE") == "false" ? true : activeDataValue);
      localStorage.setItem("userTimeZone", userTimeZone);
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.SUCCESS, "User preference saved successfully")
      if (getEnv("REACT_APP_PARTITION_MODE") == "true" && isActiveData != activeDataValue)
        navigate(AuthRoutes.STUDYLIST);
    } else {
      setLoaderRunning(false);
      ref.current.complete();
      showToastv2(TOAST_TYPE.ERROR, "Error while saving user preference")
    }
  }

  const setStudyListDateSearchFilter = useCallback((e, option) => {
    if (option.key === 1) {
      setPreferenceData(prev => ({ ...prev, studylistSearchDateFilter: 1 }));
    } else if (option.key === 2) {
      setPreferenceData(prev => ({ ...prev, studylistSearchDateFilter: 2 }));
    }
  }, []);

  const setStudyListOrderBy = useCallback((e, option) => {
    if (option) {
      const selectedKey = option.key;
      setStudylistOrderBy(selectedKey);
      setPreferenceData(prev => ({ ...prev, studylistOrderBy: selectedKey }));
    }
  }, []);

  const setNoOfImagesFilterPreference = useCallback((e, option) => {
    if (option) {
      const selectedKey = option.key === "" ? null : option.key;
      setNoOfImagesFilter(selectedKey);
      setPreferenceData(prev => ({ ...prev, noOfImagesFilter: selectedKey }));
    }
  }, []);

  const isFirmTechnicianOnly = props.loggedInUserRole === USERTYPES.FIRMTECHNICIAN;
  const canConfigureAutoSaveReport =
    props.loggedInUserRole === USERTYPES.RADIOLOGIST ||
    props.loggedInUserRole === USERTYPES.TYPIST;

  return (
    <div className="tab-section" style={{ paddingBottom: '48px' }}>
      {!isFirmTechnicianOnly && (
      <>
      <section className="sectionA">
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            padding: "0px 0px",
            marginBottom:"28px"
          }}
        >
          {t("account-and-settings.user-preferences")}
        </p>
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            padding: "0px 0px",
            marginBottom:"28px"
          }}
        >
          Study Viewer
        </p>
      </section>
      {(props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST) && 
      <>
       {true && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
          <div className="ms-Grid-row">  
            <div style={{ display: 'flex', alignItems: 'center' }}>
          <p className="single-line-form-field-key" style={{ width: '250px' }}>
            {t("account-and-settings.viewer-for-non-X-ray-studies")}
          </p>
          
        </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
              <div>
                
                <ChoiceGroup
                  selectedKey={
                    preferenceData.nonXrayAdvanceViewer ? 2 : 1 
                  }
                  options={viewerForNonXRAYOptions}
                  styles={choiceGroupStyles}
                  onChange={(e, option) =>
                    setPreferenceData(prev => ({
                      ...prev,
                      nonXrayAdvanceViewer: option.key === 2
                    }))
                  }
                />
              </div>
            </div>
          </div>
        </div>}
      
      {props.loggedInUserRole === USERTYPES.RADIOLOGIST && <>
        <div className="ms-Grid" dir="ltr">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              <p><b>{t("account-and-settings.default-ai-representation")}</b></p>
            </div>
          </div>
          <div className="ms-Grid-row">  
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.outline")}
                checked={!!preferenceData.outline}
                onChange={() => {
                  setPreferenceData(prev => ({
                    ...prev,
                    outline: !prev.outline
                  }))
                }}
                
              />                  
            </div>
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.heatmap")}
                checked={!!preferenceData.heatMap}
                onChange={() => {
                  setPreferenceData(prev => ({
                    ...prev,
                    heatMap: !prev.heatMap
                  }))
                }}
              />                   
            </div>
          </div>
        </div>

        {/* Auto Open Report Panel */}
        <div className="ms-Grid" dir="ltr" style={{ marginTop: '12px' }}>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              <p><b>{t("account-and-settings.auto-open-report-panel")}</b></p>
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.no-abnormality")}
                checked={preferenceData.autoOpenNoAbnormality !== undefined ? !!preferenceData.autoOpenNoAbnormality : true}
                onChange={() =>
                  setPreferenceData(prev => ({
                    ...prev,
                    autoOpenNoAbnormality: !(prev.autoOpenNoAbnormality !== undefined ? prev.autoOpenNoAbnormality : true)
                  }))
                }
              />
            </div>
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.fo-only")}
                checked={!!preferenceData.autoOpenFoOnly}
                onChange={() =>
                  setPreferenceData(prev => ({
                    ...prev,
                    autoOpenFoOnly: !prev.autoOpenFoOnly
                  }))
                }
              />
            </div>
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.abnormality")}
                checked={!!preferenceData.autoOpenAbnormality}
                onChange={() =>
                  setPreferenceData(prev => ({
                    ...prev,
                    autoOpenAbnormality: !prev.autoOpenAbnormality
                  }))
                }
              />
            </div>
            <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
              <Checkbox
                label={t("account-and-settings.no-ai-detection")}
                checked={!!preferenceData.autoOpenNoAiDetection}
                onChange={() =>
                  setPreferenceData(prev => ({
                    ...prev,
                    autoOpenNoAiDetection: !prev.autoOpenNoAiDetection
                  }))
                }
              />
            </div>
          </div>
        </div>

        {getEnv("REACT_APP_VDC_PLATFORM") === "true" && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              <p><b>Study list Search Date Filter</b></p>
            </div>
        </div>
        <div className="ms-Grid-row">  
          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
            <div>
              <ChoiceGroup
                selectedKey={preferenceData.studylistSearchDateFilter ?? null}
                options={studylistDateSearchFilter}
                styles={choiceGroupStyles}
                onChange={(e, option) =>
                  setPreferenceData(prev => ({
                    ...prev,
                    studylistSearchDateFilter: option.key
                  }))
                }
              />
            </div>
          </div>
        </div>
      </div> }
      </>
      }
      {weasisViewerUser && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
            {/* <p>Weasis Viewer download link: <a href="https://weasis.org/en/getting-started/download-dicom-viewer/" target='_blank' style={{color : "gray"}}>download</a></p> */}
            <p>Weasis Viewer download link: <a href="https://weasis.org/en/getting-started/download-dicom-viewer/" target='_blank' style={{color : "blue"}}>download</a></p>
            </div>
        </div>
      </div> }

      {infinitViewerUser && !weasisViewerUser && <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
              {/* <p>Infinit Viewer download link: <a href="https://pacs.carepointhealth.com/InstallStarter.msi" target='_blank' style={{color : "gray"}}>download</a></p> */}
              <p>Infinit Viewer download link: <a href="https://pacs.carepointhealth.com/InstallStarter.msi" target='_blank' style={{color : "blue"}}>download</a></p>
              </div>
        </div>
      </div> }
      </>
      }

 
  <>
    {props.loggedInUserRole === USERTYPES.RADIOLOGIST && (
    <div className="ms-Grid-row single-line-form-field">
      <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
        <div style={{ display: "flex", alignItems: "center" }}>
          <p className="single-line-form-field-key" style={{ width: "250px" }}>
            {t("account-and-settings.auto-populate-pathology", "Auto-populate pathology sentence")}
          </p>
          <div className="checkbox-container" style={{ width: "24px" }}>
            <Checkbox
              checked={!!preferenceData.autoPopulateManualPathology}
              onChange={(_, checked) =>
                setPreferenceData((prev) => ({
                  ...prev,
                  autoPopulateManualPathology: !!checked,
                }))
              }
            />
          </div>
        </div>
        <p style={{ fontSize: "13px", color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: "0px" }}>
          Automatically adds a sentence to the Agentic Report chat box when you manually select a pathology from the menu.
        </p>
      </div>
    </div>
    )}

    {canConfigureAutoSaveReport && (
    <div className="ms-Grid-row single-line-form-field">
      <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
        <div style={{ display: "flex", alignItems: "center" }}>
          <p className="single-line-form-field-key" style={{ width: "250px" }}>
            Auto Save Report Draft
          </p>
          <div className="checkbox-container" style={{ width: "24px" }}>
            <Checkbox
              checked={!!preferenceData.autoSaveReport}
              onChange={(_, checked) =>
                setPreferenceData((prev) => ({
                  ...prev,
                  autoSaveReport: !!checked,
                }))
              }
            />
          </div>
        </div>
        <p style={{ fontSize: "13px", color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: "0px" }}>
          Periodically saves a draft of the report while you type. You can also use Save Draft. Use Preliminary for an official shareable version; Final is stored when you Submit.
        </p>
      </div>
    </div>
    )}
  </>

  {(props.loggedInUserRole !== USERTYPES.FIRMTECHNICIAN && props.loggedInUserRole !== USERTYPES.TYPIST) &&
  <>
    <div className="ms-Grid-row single-line-form-field">
      <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p className="single-line-form-field-key" style={{ width: '250px' }}>
            {t("account-and-settings.prefetch-entire-study")}
          </p>
          <div className="checkbox-container" style={{ width: '24px' }}>
            <Checkbox
              checked={prefetchEntireStudy}
              value={prefetchEntireStudy}
              styles={choiceGroupStyles}
              onChange={(e, checked) => {
                setPrefetchEntireStudy(checked);
                if(prefetchCount == -1)
                  setPrefetchCount(50);
              }}
            />
          </div>
        </div>
          <p style={{ fontSize: '13px', color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: '0px' }}>
            {t("account-and-settings.prefetch-entire-study-note")}
          </p>
      </div>
    </div>

    {!prefetchEntireStudy && (
      <div className="ms-Grid-row single-line-form-field">
              <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
                <div style={{display: "flex", alignItems: "center"}}>
                <p className="single-line-form-field-key" style={{ width: "250px" }}>
                  {t("account-and-settings.prefetch-count")}
                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          marginLeft: "2px",
                          color: "rgb(164, 38, 44)",
                          fontSize: "small",
                        }}
                      >
                        *
                      </span>
                      </p>
                      <div style={{ width: "100px" }}>
                        <TextField
                          className={"form-field ms-sm12 ms-md8 ms-lg4 ms-xl12"}
                          name="prefetch"
                          placeholder={t("account-and-settings.prefetch-count")}
                          type="number"
                          value={prefetchCount}
                          onChange={handleChange}
                          //errorMessage={errorMessage}
                        />
                      </div>
                      </div>
                      {/* Error Message Below the Input Field */}
                      {errorMessage && (
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "-10px",
                            marginLeft: "252px",
                            fontWeight: "700",
                          }}
                        >
                          {errorMessage}
                        </div>
                      )}
                      <p style={{ fontSize: "13px", color: themeName === "light" ? "#808080" : "#bebebe" }}>
                      {t("account-and-settings.autoload-note")}
                    </p>
                  </div>
                  </div>
            )}

          <div className="ms-Grid-row single-line-form-field">
            <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
              <div style={{ display: "flex", alignItems: "center" }}>
                <p className="single-line-form-field-key" style={{ width: "250px" }}>
                  {t("account-and-settings.cine-frames-per-second")}
                  <span
                    style={{
                      position: "absolute",
                      top: "10px",
                      marginLeft: "2px",
                      color: "rgb(164, 38, 44)",
                      fontSize: "small",
                    }}
                  >
                    *
                  </span>
                </p>
                <div style={{ width: "100px" }}>
                  <TextField
                    className={"form-field ms-sm12 ms-md8 ms-lg4 ms-xl12"}
                    name="cineFramesPerSecond"
                    placeholder={t("account-and-settings.cine-frames-per-second")}
                    type="number"
                    value={cINEFramesPerSecond}
                    onChange={handleCineFramesPerSecondChange}
                    //errorMessage={errorMessage}
                  />
                </div>
              </div>
              {/* Error Message Below the Input Field */}
              {cineErrorMessage && (
                <div
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginTop: "-10px",
                    marginLeft: "252px",
                    fontWeight: "700",
                  }}
                >
                  {cineErrorMessage}
                </div>
              )}
              <p
                style={{
                  fontSize: "13px",
                  color: themeName === "light" ? "#808080" : "#bebebe",
                }}
              >
                {t("account-and-settings.cine-frames-per-second-note")}
              </p>
            </div>
          </div>

      <div className="ms-Grid-row single-line-form-field">
        <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl6">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p className="single-line-form-field-key" style={{ width: '250px' }}>
              {t("account-and-settings.two-monitor-requirement")}
            </p>
            <div className="checkbox-container" style={{ width: '24px' }}>
              <Checkbox
                checked={twoMonitorEnabled}
                value={twoMonitorEnabled}
                onChange={handleTwoMonitorChange}
              />
            </div>
          </div>
          {/* <p style={{ fontSize: '13px', color: '#bebebe', marginLeft: '0px' }}> */}
          <p style={{ fontSize: '13px', color: themeName === "light" ? "#808080" : "#bebebe", marginLeft: '0px' }}>
            {t("account-and-settings.two-monitor-requirement-note1")}
          </p>
        </div>
      </div>
                </>
}
      </>
      )}

      <section className="sectionA" style={{ paddingTop: isFirmTechnicianOnly ? "0" : "40px" }}>
        <p
          style={{
            fontSize: "20px",
            fontWeight: "600",
            padding: "0px 0px",
            marginBottom:"28px"
          }}
        >
          {t("account-and-settings.study-list")}
        </p>
      </section>
      <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
            <div>
              <p style={{
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                color: themeName === "light" ? "#323130" : "#ffffff"
              }}>
                {t("account-and-settings.select-default-sort")}
              </p>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '1em'
              }}>
                <div className="ms-ChoiceField">
                  <div className="ms-ChoiceField-wrapper">
                    <input
                      id="studylist-option-1"
                      className="ms-ChoiceField-input"
                      type="radio"
                      name="studylistOrderBy"
                      checked={studylistOrderBy === 1}
                      onChange={() => setStudyListOrderBy(null, { key: 1 })}
                      style={{
                        width: '18px',
                        height: '18px',
                        margin: '2px 8px 2px 0'
                      }}
                    />
                    <label htmlFor="studylist-option-1" className="ms-ChoiceField-field">
                      <span className="ms-ChoiceFieldLabel">Created On (Default)</span>
                    </label>
                  </div>
                  <p style={{
                    fontSize: '13px',
                    color: themeName === "light" ? "#808080" : "#bebebe",
                    marginLeft: '20px',
                    marginTop: '2px'
                  }}>
                    {t("account-and-settings.study-list-assigned-on-description")}
                  </p>
                </div>

                <div className="ms-ChoiceField">
                  <div className="ms-ChoiceField-wrapper">
                    <input
                      id="studylist-option-2"
                      className="ms-ChoiceField-input"
                      type="radio"
                      name="studylistOrderBy"
                      checked={studylistOrderBy === 2}
                      onChange={() => setStudyListOrderBy(null, { key: 2 })}
                      style={{
                        width: '18px',
                        height: '18px',
                        margin: '2px 8px 2px 0'
                      }}
                    />
                    <label htmlFor="studylist-option-2" className="ms-ChoiceField-field">
                      <span className="ms-ChoiceFieldLabel">Emergency</span>
                    </label>
                  </div>
                  <p style={{
                    fontSize: '13px',
                    color: themeName === "light" ? "#808080" : "#bebebe",
                    marginLeft: '20px',
                    marginTop: '2px'
                  }}>
                    {t("account-and-settings.study-list-emergency-description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ms-Grid" dir="ltr" style={{marginBottom:"20px"}}>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 ">
            <div>
              <p style={{
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                color: themeName === "light" ? "#323130" : "#ffffff"
              }}>
                Select Default Filters:
              </p>
              <p style={{
                fontSize: '14px',
                fontWeight: '600',
                marginBottom: '10px',
                color: themeName === "light" ? "#323130" : "#ffffff"
              }}>
                No Of Images: {noOfImagesFilter === null ? "Any (Default)" : noOfImagesFilter === NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES ? "0" : "> 0"}
              </p>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1em'
                }}>
                  <div className="ms-ChoiceField">
                    <div className="ms-ChoiceField-wrapper">
                      <input
                        id="noofimages-option-any"
                        className="ms-ChoiceField-input"
                        type="radio"
                        name="noOfImagesFilter"
                        checked={noOfImagesFilter === null}
                        onChange={() => setNoOfImagesFilterPreference(null, { key: "" })}
                        style={{
                          width: '18px',
                          height: '18px',
                          margin: '2px 8px 2px 0'
                        }}
                      />
                      <label htmlFor="noofimages-option-any" className="ms-ChoiceField-field">
                        <span className="ms-ChoiceFieldLabel">Any (Default)</span>
                      </label>
                    </div>
                  </div>

                  <div className="ms-ChoiceField">
                    <div className="ms-ChoiceField-wrapper">
                      <input
                        id="noofimages-option-zero"
                        className="ms-ChoiceField-input"
                        type="radio"
                        name="noOfImagesFilter"
                        checked={noOfImagesFilter === NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES}
                        onChange={() => setNoOfImagesFilterPreference(null, { key: NO_OF_IMAGES_STATUS.ZERO_NO_OF_IMAGES })}
                        style={{
                          width: '18px',
                          height: '18px',
                          margin: '2px 8px 2px 0'
                        }}
                      />
                      <label htmlFor="noofimages-option-zero" className="ms-ChoiceField-field">
                        <span className="ms-ChoiceFieldLabel">0</span>
                      </label>
                    </div>
                  </div>

                  <div className="ms-ChoiceField">
                    <div className="ms-ChoiceField-wrapper">
                      <input
                        id="noofimages-option-more-than-zero"
                        className="ms-ChoiceField-input"
                        type="radio"
                        name="noOfImagesFilter"
                        checked={noOfImagesFilter === NO_OF_IMAGES_STATUS.MORE_THAN_ZERO_NO_OF_IMAGES}
                        onChange={() => setNoOfImagesFilterPreference(null, { key: NO_OF_IMAGES_STATUS.MORE_THAN_ZERO_NO_OF_IMAGES })}
                        style={{
                          width: '18px',
                          height: '18px',
                          margin: '2px 8px 2px 0'
                        }}
                      />
                      <label htmlFor="noofimages-option-more-than-zero" className="ms-ChoiceField-field">
                        <span className="ms-ChoiceFieldLabel">{'>'} 0</span>
                      </label>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ms-Grid-row single-line-form-field">
        <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
          <div style={{ display: "flex", alignItems: "center" }}>
            <p className="single-line-form-field-key" style={{ width: 250 }}>
              {t("account-and-settings.timezone") || "Time Zone"}
            </p>
            <div className="ms-sm12 ms-md10 ms-lg8 ms-xl4">  
              <Select
                classNamePrefix="react-select"
                options={timeZoneOptions}
                value={timeZoneOptions.find(tz => tz.value === userTimeZone)}
                isSearchable
                onChange={(item) => setUserTimeZone(item.value)}
                styles={{
                  control: (base) => ({
                    ...base,
                    width: "100%",
                    color: getThemeColor("primary-color"),
                    backgroundColor: getThemeColor("action-details-background"),
                    border: getThemeColor("border"),
                  }),
                  menu: (base) => ({
                    ...base,
                    backgroundColor: getThemeColor("action-details-background"),
                  }),
                  option: (base, state) => ({
                    ...base,
                    color: getThemeColor("primary-color"),
                    backgroundColor: state.isFocused
                      ? getThemeColor("popup-hover")
                      : getThemeColor("action-details-background"),
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: getThemeColor("primary-color"),
                  }),
                  input: (base) => ({
                    ...base,
                    color: getThemeColor("primary-color"), 
                  }),
                }}
              />

            </div>
          </div>
          <p
            style={{
              fontSize: 13,
              color: themeName === "light" ? "#808080" : "#bebebe",
            }}
          >
            {t("account-and-settings.timezone-note")}
          </p>
        </div>
      </div>
      
      {props.loggedInUserRole === USERTYPES.RADIOLOGIST && (
      <div className="ms-Grid-row single-line-form-field">
        <div className="ms-Grid-col ms-sm12 ms-lg8 single-line-form-field-value">
          <fieldset className="border rounded p-4" style={{ marginTop: '15px', marginBottom: '8px', maxWidth: '300px' }}>
            <legend className="single-line-form-field-key" style={{ width: 'auto', padding: '0 8px', fontWeight: '600' }}>
              Auto PDF Preview
            </legend>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  id="pdf-preview-disable"
                  type="radio"
                  name="pdfPreviewPreference"
                  value={0}
                  checked={pdfPreviewPreference === 0}
                  onChange={() => setPdfPreviewPreference(0)}
                  style={{
                    width: '18px',
                    height: '18px',
                    margin: '2px 8px 2px 0'
                  }}
                />
                <label htmlFor="pdf-preview-disable" style={{ cursor: 'pointer' }}>
                  <span style={{ fontSize: '14px' }}>Disable  (Default)</span>
                </label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  id="pdf-preview-onsave"
                  type="radio"
                  name="pdfPreviewPreference"
                  value={1}
                  checked={pdfPreviewPreference === 1}
                  onChange={() => setPdfPreviewPreference(1)}
                  style={{
                    width: '18px',
                    height: '18px',
                    margin: '2px 8px 2px 0'
                  }}
                />
                <label htmlFor="pdf-preview-onsave" style={{ cursor: 'pointer' }}>
                  <span style={{ fontSize: '14px' }}>On Save</span>
                </label>
              </div>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <input
                  id="pdf-preview-onsaveandsubmit"
                  type="radio"
                  name="pdfPreviewPreference"
                  value={2}
                  checked={pdfPreviewPreference === 2}
                  onChange={() => setPdfPreviewPreference(2)}
                  style={{
                    width: '18px',
                    height: '18px',
                    margin: '2px 8px 2px 0'
                  }}
                />
                <label htmlFor="pdf-preview-onsaveandsubmit" style={{ cursor: 'pointer' }}>
                  <span style={{ fontSize: '14px' }}>On Save and Submit</span>
                </label>
              </div>
            </div>
          </fieldset>
        </div>
      </div>
      )}


      <div className="left-side-button-container" >
        <PrimaryButton
          style={{
            background: "#2F80ED",
            borderRadius: "5px",
          }}
          text={t("button.save")}
          onClick={handleSubmitClick}
        />
      </div>


      
      
    </div>
  )
}

export default PreferenceSettings